import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { leadQueryKeys } from "../lead";
import { taskQueryKeys } from "./taskQueryKeys";

export function useTaskDelete({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (taskId: number) => {
      await api.taskApi.remove(taskId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.list() });
    },
  });
}
